import * as PropTypes from "prop-types"
import React, {Component, Fragment} from "react"
import {Button, Input, Popup, Icon} from "semantic-ui-react"
import Responsive                                                from "react-responsive"
import shop from "shop/shop"


const showWarningToast = msg => {
	shop.toast( msg, "warning", false, "bottom" )
}


class ProductCount extends Component {


	state = {
		rahmenauftragcount: 0
	}

	render() {
		let {product, onChange, rahmenauftrag} = this.props
		let {rahmenauftragcount} = this.state
		let showVEWarning = shop.config.checkout.limitToStock && (product.count >= Math.floor( product.stock / product.unit_multi ))

		console.log("PRODUCT COUNT: ", product, rahmenauftrag)
		return (<Fragment>
			<Responsive minWidth={789}>
			<Input style={{borderRadius: "35px", height: "50px"}} className="flex flex-row justify-end transparent ba b--black-20 bw1 pr2 pl2 text-center"
				onChange={async ( e ) => {
					if( !e.target.value || e.target.value === "0" ) {
						console.log("ProductCount: No value entered, setting count to 1")
						product.count = 1
						return onChange( {product, count: 1} )
					}
					const count = Math.round( e.target.value)

					if (rahmenauftrag ) {
						if(e.target.value >= Math.floor( product.count - (product.open / product.unit_multi)  ) ) {
							showWarningToast( "Maximale Abnahmemenge angepasst" )
							this.setState({rahmenauftragcount: Math.floor( product.count - (product.open / product.unit_multi)  ) })
							return
						}
						//product.count = Math.floor( product.open / product.unit_multi )
						this.setState({rahmenauftragcount: count})
						return
					}

					if ( product.onChange ) {
						let ok = product.onChange( product )
						if ( !ok ) {
							showWarningToast( "Maximale Abnahmemenge erreicht" )
							return false
						}
					}
					product.count = Number( count )
					onChange( {product, count: count} )
				}}
				type="number"
				placeholder="0"
				action>
									<Button style={{borderRadius: "35px", backgroundColor: "#ffffff"}}
					size="tiny"
					icon="minus"
					onClick={() => {
						if (rahmenauftrag) {
							this.setState({rahmenauftragcount: Math.max(0, rahmenauftragcount - 1)})
							return
						}
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count - 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count = Math.max( product.count - 1, 0 )
						onChange( {product} )
					}} />
				<input value={ rahmenauftrag ? rahmenauftragcount : product.count } tabIndex={99} style={{ width: rahmenauftrag ? "150px" : "60px", height: "50px", textAlign: "center", border: "none"}} />

				<Button style={{borderRadius: "35px", backgroundColor: "#ffffff" }}
					size="tiny"
					icon="plus"
					onClick={() => {
						if (rahmenauftrag) {
							if(rahmenauftragcount >= Math.floor( product.count - (product.open / product.unit_multi)  ) ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return
							}
							this.setState({rahmenauftragcount: rahmenauftragcount + 1})
							return
						}
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count + 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count += 1
						onChange( {product} )
					}} />
				{showVEWarning &&
				<Popup trigger={<Button circular icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager" />}
					   content="Keine weiteren Artikel auf Lager" />}
			</Input>
			{rahmenauftrag && 		<div className="pt2">
			<Button style={{borderRadius: "35px", backgroundColor: "#369678", color: "#ffffff", height: "50px", width: "235px"}}
				size="tiny"
				onClick={async () => {
					let rahmenauftragproduct = await shop.product( product.article_id )
					rahmenauftragproduct.count = rahmenauftragcount
					shop.cart.add( rahmenauftragproduct )
					shop.toast( translate( "Produkt hinzugefügt" ), "success", false, "bottom" )
				}}>
				<p className="f6 fw6 "><Icon name={"shopping cart"}/>&nbsp; {translate("In den Warenkorb")}</p>
			</Button></div>	}
			</Responsive>
			<Responsive maxWidth={789}>
				<div className="flex flex-row justify-between">
					<div className="pt2">
								<Input style={{borderRadius: "35px", height: "50px"}} className="flex flex-row justify-end transparent ba b--black-20 bw1 pr2 pl2 text-center"
				onChange={async ( e ) => {
					if( !e.target.value || e.target.value === "0" ) {
						console.log("ProductCount: No value entered, setting count to 1")
						product.count = 1
						return onChange( {product, count: 1} )
					}
					const count = Math.round( e.target.value)

					if (rahmenauftrag ) {
						if(e.target.value >= Math.floor( product.count - (product.open / product.unit_multi)  ) ) {
							showWarningToast( "Maximale Abnahmemenge angepasst" )
							this.setState({rahmenauftragcount: Math.floor( product.count - (product.open / product.unit_multi)  ) })
							return
						}
						//product.count = Math.floor( product.open / product.unit_multi )
						this.setState({rahmenauftragcount: count})
						return
					}

					if ( product.onChange ) {
						let ok = product.onChange( product )
						if ( !ok ) {
							showWarningToast( "Maximale Abnahmemenge erreicht" )
							return false
						}
					}
					product.count = Number( count )
					onChange( {product, count: count} )
				}}
				type="number"
				placeholder="0"
				action>
									<Button style={{borderRadius: "35px", backgroundColor: "#ffffff"}}
					size="tiny"
					icon="minus"
					onClick={() => {
						if (rahmenauftrag) {
							this.setState({rahmenauftragcount: Math.max(0, rahmenauftragcount - 1)})
							return
						}
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count - 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count = Math.max( product.count - 1, 0 )
						onChange( {product} )
					}} />
				<input value={ rahmenauftrag ? rahmenauftragcount : product.count } tabIndex={99} style={{ width: rahmenauftrag ? "60px" : "60px", height: "50px", textAlign: "center", border: "none"}} />

				<Button style={{borderRadius: "35px", backgroundColor: "#ffffff" }}
					size="tiny"
					icon="plus"
					onClick={() => {
						if (rahmenauftrag) {
							if(rahmenauftragcount >= Math.floor( product.count - (product.open / product.unit_multi)  ) ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return
							}
							this.setState({rahmenauftragcount: rahmenauftragcount + 1})
							return
						}
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.stock / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count + 1} )
							if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}
						}
						product.count += 1
						onChange( {product} )
					}} />
				{showVEWarning &&
				<Popup trigger={<Button circular icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager" />}
					   content="Keine weiteren Artikel auf Lager" />}
			</Input>
			</div>
			{rahmenauftrag && 		<div className="pt2">
			<Button style={{borderRadius: "35px", backgroundColor: "#369678", color: "#ffffff", height: "50px", width: "235px"}}
				size="tiny"
				onClick={async () => {
					let rahmenauftragproduct = await shop.product( product.article_id )
					rahmenauftragproduct.count = rahmenauftragcount
					shop.cart.add( rahmenauftragproduct )
					shop.toast( translate( "Produkt hinzugefügt" ), "neutral", false, "bottom" )
				}}>
				<p className="f6 fw6 "><Icon name={"shopping cart"}/>&nbsp; {translate("In den Warenkorb")}</p>
			</Button></div>}
				</div>
				</Responsive>
		</Fragment>)
	}
}

ProductCount.propTypes = {
	product : PropTypes.any,
	onChange: PropTypes.any
}


export default ProductCount



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Product/ProductCount.js